import React, { PropsWithChildren } from "react";

import { cn } from "@perceptron/utils/cn";

export interface EditorContainerProps {
  isLoading: boolean;
  className?: string;
}

/**
 * Container component for the editor that handles visual states and loading.
 * Memoized to prevent unnecessary re-renders when parent re-renders.
 *
 * @param props Container configuration
 * @returns Rendered container
 */
export const EditorContainer = React.memo(
  ({ isLoading, children, className }: PropsWithChildren<EditorContainerProps>) => {
    return (
      <div className={cn("relative flex min-h-0 flex-1 flex-col", className)}>
        <div
          className={cn(
            "editor-container flex min-h-0 flex-1 flex-col transition-opacity duration-200",
            isLoading ? "opacity-0" : "opacity-100",
          )}
        >
          {children}
        </div>
      </div>
    );
  },
);

EditorContainer.displayName = "EditorContainer";
